import { type AxiosInstance } from "axios";
import { type GetPartnerLimitResponse } from "@/features/partner/types";

/**
 * 指定パートナーの連携上限件数を取得する。
 *
 * @param apiClient - 認証済み axios インスタンス
 * @param partnerId - 連携先パートナーID
 * @returns 連携上限件数（1リクエストあたりに連携可能な物件数）
 */
export const getPartnerLimit = async (
  apiClient: AxiosInstance,
  partnerId: number
): Promise<GetPartnerLimitResponse> => {
  const response = await apiClient.get<GetPartnerLimitResponse>(
    `/partner/${partnerId}/limit`
  );
  return response.data;
};
